<template>
	<b-modal
	v-model="modalShow"
	size="lg"
	header-bg-variant="dark"
	header-text-variant="white"
	header-close-variant="white"
	hide-footer
	>
		<template v-slot:modal-title>
			<h3><span v-if="type='creation'">Créez</span> <span v-else>Domiciliez</span> votre entreprise</h3>
		</template>

		<template v-slot:default>
			<b-form @submit.stop.prevent="sendContactMail" class="mb-3">
				<h1 class="mb-3">Être recontacté par un conseiller</h1>
				<p class="mb-4">Expliquez-nous votre projet.</p>

				<b-form-row>
					<b-col>
						<b-form-group label="Nom de l'entreprise" label-for="company-name" invalid-feedback="Le nom de l'entreprise est obligatoire">
							<b-input
							id="company-name"
							v-model="$v.contactForm.companyName.$model"
							:state="validateState('companyName')"
							aria-describedby="company-name-live-feedback"
							autofocus />
						</b-form-group>
					</b-col>

					<b-col>
						<b-form-group label="Activité de l'entreprise" label-for="company-activity" invalid-feedback="L'activité de l'entreprise est obligatoire">
							<b-input
							id="company-activity"
							v-model="$v.contactForm.companyActivity.$model"
							:state="validateState('companyActivity')"
							aria-describedby="company-activity-live-feedback" />
						</b-form-group>
					</b-col>
				</b-form-row>

				<b-form-row>
					<b-col>
						<b-form-group label="Téléphone" label-for="phone">
							<b-input-group prepend="📞">
								<b-input
								id="phone"
								v-model="$v.contactForm.companyPhone.$model"
								:state="validateState('companyPhone')"
								aria-describedby="company-phone-live-feedback" />

									<b-form-invalid-feedback id="company-phone-live-feedback">
									Le numéro de téléphone est obligatoire, doit être au format numérique et comporter 10 chiffres.
								</b-form-invalid-feedback>
							</b-input-group>
						</b-form-group>
					</b-col>

					<b-col>
						<b-form-group label="Email" label-for="mail-address">
							<b-input-group prepend="@">
								<b-input
								id="mail-adress"
								v-model="$v.contactForm.companyMailAddress.$model"
								:state="validateState('companyMailAddress')"
								aria-describedby="company-mail-address-live-feedback" />

									<b-form-invalid-feedback id="company-mail-address-live-feedback">
									L'adresse mail est obligatoire et doit être au format "xxx@xxx.xx"
								</b-form-invalid-feedback>
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-form-row>

				<b-form-group label="Objet" label-for="subject" invalid-feedback="L'objet est obligatoire">
					<b-input
					id="subject"
					v-model="$v.contactForm.subject.$model"
					:state="validateState('subject')"
					aria-describedby="subject-live-feedback"
					:placeholder="getSubject" />
				</b-form-group>

				<b-form-group label="Message" label-for="message" invalid-feedback="Le message est obligatoire.">
					<b-form-textarea
					id="message"
					v-model="$v.contactForm.message.$model"
					:state="validateState('message')"
					rows="3"
					max-rows="6"
					aria-describedby="message-live-feedback"
					placeholder="Je souhaite créer mon entreprise..." />
				</b-form-group>

				<b-alert variant="warning" :show="pending">
					<p>Votre message est en cours d'envoi. Merci de patienter quelques instants...</p>
				</b-alert>

				<b-alert variant="success" :show="sent" dismissible>
					<p>Votre message a bien été envoyé. Nous vous répondrons dans les plus brefs délais. Merci.</p>
					<p>Vous allez être redirigé vers la plage d'accueil dans un instant...</p>
				</b-alert>

				<b-alert variant="danger" :show="errored" dismissible>
					<p>Une erreur est survenue... Merci de réessayer ultérieurement.</p>
				</b-alert>

				<b-button type="submit" size="lg" class="mt-3">Valider</b-button>
			</b-form>

			<p class="text-black-50 text-center">En soumettant ce formulaire, j'accepte que {{ appName }} réponde par email ou téléphone à ma demande.</p>
		</template>
	</b-modal>
</template>

<script>
	import { mapState } from 'vuex';

	import { required, email, numeric, minLength, maxLength } from "vuelidate/lib/validators";

	import axios from 'axios';

	export default {
		props: {
			modalShow: {
				type: Boolean,
				required: true
			},
			type: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				contactForm : {
					companyName : null,
					companyActivity : null,
					companyPhone : null,
					companyMailAddress : null,
					subject : null,
					message : null
				},
				pending : false,
				sent : false,
				errored : false
			}
		},
		validations: {
			contactForm: {
				companyName : { required },
				companyActivity : { required },
				companyPhone : {
					required,
					numeric,
					minLength: minLength(10),
					maxLength: maxLength(10)
				},
				companyMailAddress : {
					required,
					email
				},
				subject : { required },
				message : { required }
			}
		},
		methods: {
			validateState(data) {
				const { $dirty, $error } = this.$v.contactForm[data];
				return $dirty ? !$error : null;
			},
			sendContactMail() {
				// Form Validation
				this.$v.contactForm.$touch();

				if (this.$v.contactForm.$anyError)
					return (this.$v.contactForm.$anyError)

				// Mail request
				this.pending = true;

				let requestTarget = this.apiDomain + '/send-email';

				axios.post(requestTarget, {
						type        : 'simpleMail',
						mailService : this.mailService,
						mailOptions : {
							from    : this.contactForm.companyMailAddress,
							to      : this.mailService.auth.user,
							subject : this.contactForm.subject,
							html    : `
									<p>${this.contactForm.message}</p>
									<p>Nom de l'entreprise : ${this.contactForm.companyName} </p>
									<p>Activité de l'entreprise : ${this.contactForm.companyActivity} </p>
									<p>Téléphone : ${this.contactForm.companyPhone}</p>
							`
						}
				})
				.then((response) => {
					this.pending = false;

					if (response.data.success === true) {
						this.sent = true;

						setTimeout(() => {
							this.$router.push('/');
						}, 5000);
					} else {
						this.errored = true;
					}
				})
				.catch(() => {
					this.pending = false;
					this.errored = true;
				});
			}
		},
		computed : {
			getSubject () {
				if (this.type === 'creation') {
					return "Création d'entreprise"
				} else {
					return "Domiciliation d'entreprise"
				}
			},
			...mapState(['appName', 'apiDomain', 'mailService']),
		}
	}
</script>
